export const CONSENT_COOKIE = "mlx_consent";
export const CONSENT_ID_COOKIE = "mlx_consent_id";
export const CONSENT_PENDING_COOKIE = "mlx_consent_pending";
export const CONSENT_VERSION = 1;
export const CONSENT_MAX_AGE = 180 * 24 * 60 * 60;
export type ConsentChoice = { analytics: boolean; advertising: boolean };
export type Consent = ConsentChoice & { version: number; revision: string; expiresAt: number };

export function parseConsent(value: string | undefined, now = Date.now()): Consent | null {
  try {
    if (!value || value.length > 1000) return null;
    const c = JSON.parse(decodeURIComponent(value));
    if (c.version !== CONSENT_VERSION || typeof c.analytics !== "boolean" ||
      typeof c.advertising !== "boolean" || typeof c.revision !== "string" ||
      !/^[0-9a-f-]{36}$/i.test(c.revision) || !Number.isSafeInteger(c.expiresAt) ||
      c.expiresAt <= now || c.expiresAt > now + CONSENT_MAX_AGE * 1000 + 60_000) return null;
    return c;
  } catch { return null; }
}

export function cookieValue(header: string | null, name: string): string | undefined {
  return header?.split(";").map(p => p.trim()).find(p => p.startsWith(`${name}=`))?.slice(name.length + 1);
}

export function consentCookie(consent: Consent): string {
  return `${CONSENT_COOKIE}=${encodeURIComponent(JSON.stringify(consent))}; Path=/; Max-Age=${CONSENT_MAX_AGE}; SameSite=Lax; Secure`;
}
